import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import { useThemeContext } from '@crema/context/AppContextProvider/ThemeContextProvider';
import AppImage from '@crema/components/AppImage';

const AppLogo = () => {
  const navigate = useNavigate();
  const { theme } = useThemeContext();
  return (
    <Box
      sx={{
        height: { xs: 56, sm: 70 },
        padding: 2.5,
        display: 'flex',
        flexDirection: 'row',
        cursor: 'pointer',
        alignItems: 'center',
        justifyContent: 'center',
        '& svg': {
          height: { xs: 40, sm: 45 },
        },
      }}
      className='app-logo'
      onClick={() => navigate('/')}
    >
      <AppImage
        src='/assets/images/logo-with-name.png'
        alt='blueSoft-logo'
        width={146}
        height={50}
      />
      {/* <Logo fill={theme.palette.primary.main} />
      <Box
        sx={{
          mt: 1,
          display: { xs: 'none', md: 'block' },
          '& svg': {
            height: { xs: 25, sm: 30 },
          },
        }}
      >
        <LogoText fill={alpha(theme.palette.text.primary, 0.8)} />
      </Box> */}
      <Typography
        variant='h3'
        sx={{ marginLeft: 10, color: theme.palette.text.primary }}
      >
        blueSoft Stock
      </Typography>
    </Box>
  );
};

export default AppLogo;
